import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/newsreader/wght-italic.css';
import App from './App';
// Shared component styles for @enshield/ui (Button, Field, Input, Notice …),
// which the contact form and the claim components render.
import '../../../packages/ui/src/tokens.css';
// The public design system.
import './site/tokens.css';
import './site/system.css';
import './site/shell.css';
import './site/sections.css';
// Enshield design DNA: the status language, the protection path, the
// intelligence field.
import './site/status.css';
import './site/protection-path.css';
import './site/intelligence-field.css';
import './site/commerce-flow.css';
import './site/public-documents.css';
// The claim components' presentation contract, kept verbatim.
import './site/claim.css';
import './site/premium.css';

createRoot(document.getElementById('root')!).render(<StrictMode><App/></StrictMode>);
